import React from 'react';
import EditDealContent from './content';
import EditDealProvider from 'contexts/edit-deal.context/provider';

const EditDealLayout = () => {
  return (
    <EditDealProvider>
      <EditDealContent />
    </EditDealProvider>
  );
};

export default EditDealLayout;
